<script>
  import QuantityInput from './QuantityInput.svelte';

  export let product

</script>

<div class="w-1/2 md:w-[175px]">
  <div class="mb-20 item">
    <div class="text-center h-[225px]">
      <img
        src={product.image.url}
        alt={product.name}
        height={product.image.height}
        width={product.image.width}
        class="max-w-[150px] w-full inline-block"
      />
    </div>
    <div class="text-center text-xs text-sky-primary">{product.name}</div>
    <div class="text-center my-4">
      <span class="regular-price" id="product-price-{product.id}">
        <span class="text-xs text-sky-primary">${product.price}</span>
      </span>
    </div>
    <QuantityInput bind:product />
  </div>
</div>
